import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../../assets/logo.gif";
import "./Navbar.css";

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  return (
    <div>
      <nav>
        <div className="nav-container">
          <div className="nav-logo">
            <img src={logo} alt="logo" />
          </div>
          <ul
            className={isMobile ? "nav-links-mobile" : "nav-links"}
            onClick={() => setIsMobile(false)}
          >
            <NavLink exact to="/" className="home-component">
              <li>HOME</li>
            </NavLink>
            <NavLink exact to="/tour" className="tour-component">
              <li>TOUR</li>
            </NavLink>
            <NavLink exact to="/uses" className="instructions-component">
              <li>USES</li>
            </NavLink>
            <NavLink exact to="features" className="features-component">
              <li>FEATURES</li>
            </NavLink>
            <NavLink exact to="/benefits" className="benefits-component">
              <li>BENEFITS</li>
            </NavLink>
            <NavLink exact to="/blog" className="blog-component">
              <li>BLOG</li>
            </NavLink>
          </ul>
          <button
            className="mobile-menu-icon"
            onClick={() => setIsMobile(!isMobile)}
          >
            {isMobile ? (
              <i class="fa-sharp fa-solid fa-circle-xmark fa-xs"></i>
            ) : (
              <i class="fa-solid fa-bars fa-xs"></i>
            )}
          </button>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
